export enum OPMEStatus {
  OPME_AUTORIZADO = 'OPME_AUTORIZADO',
  OPME_AUTORIZADO_COM_DIVERGENCIA = 'OPME_AUTORIZADO_COM_DIVERGENCIA',
  OPME_NEGADO = 'OPME_NEGADO',
  PEDIDO_SEM_OPME = 'PEDIDO_SEM_OPME'
}

export enum OPMEStatusTranslated {
  OPME_AUTORIZADO = 'OPME autorizado',
  OPME_AUTORIZADO_COM_DIVERGENCIA = 'OPME autorizado com divergencia',
  OPME_NEGADO = 'OPME negado',
  PEDIDO_SEM_OPME = 'Pedido sem OPME'
}
